

var win = window;
var doc = document;
 export var rempx = 100;
 var docEl = doc.documentElement;
 var resizeEvt = 'orientation' in window ? 'orientationchange' : 'resize';
 var recalc = function () {
         var clientWidth = docEl.clientWidth;
         if (!clientWidth) return;
        //  if (clientWidth < 640) {
             rempx = 100 * (clientWidth / 640);
        //  }
         docEl.style.fontSize = rempx + 'px';
         // log(rempx,"aa");
     };
//  if (!doc.addEventListener) return;
 win.addEventListener(resizeEvt, recalc2, false);
 // doc.addEventListener("DOMContentLoaded", recalc, false);
 recalc();

 function recalc2()
 {
	requestAnimationFrame(recalc);
 }
 